module.exports = new __parcel__URL__("What do you need to achieve your top priorities_ v1.65f55ff7.svg").toString();